import React from 'react';
import classNames from 'classnames';

type BaseLayoutProps = {
  className?: string;
};

export const BaseLayout: React.FC<BaseLayoutProps> = ({
  children,
  className,
}) => (
  <main className="flex-grow overflow-auto">
    <div
      className={classNames(className, 'max-w-9xl h-full mx-auto px-10 py-6')}
    >
      {children}
    </div>
  </main>
);
